export default __webpack_public_path__ + "static/media/Hand-wraps of the Unutterable.77d5bf8d.jpg";